import { useMutation } from 'react-query';

import { createGroup } from '../infrastructure/create-group';
import { useInvalidateAllGroups } from './utils/invalidate-all-groups';

export const useAddGroupMutation = () => {
    const invalidateAll = useInvalidateAllGroups();

    return useMutation({
        mutationFn: createGroup,
        onSuccess: () => {
            invalidateAll();
        },
    });
};
